<template>
    <Slide :title="title" :subtitle="subtitle">
        <div class="cr:grid cr:grid-cols-1 cr:md:grid-cols-2 cr:gap-5">
            <div>
                <p>Number of Employees</p>
                <CustomInput
                    :placeholder="'Enter number of employees'"
                    v-model="registrationStore.registeringCompany.numberOfEmployees"
                    :input-type="'number'"
                />
            </div>
            <div>
                <p>Company Turnover</p>
                <Dropdown
                    :options="turnoverOptions"
                    v-model="registrationStore.registeringCompany.companyTurnover"
                    :selected-option="registrationStore.registeringCompany.companyTurnover"
                />
            </div>
            <div>
                <p>Do you have a CRM?</p>
                <Dropdown
                    :options="yesNoOptions"
                    v-model="registrationStore.registeringCompany.usesCRM"
                    :selected-option="registrationStore.registeringCompany.usesCRM"
                />
            </div>
            <div>
                <p>Years in business</p>
                <CustomInput
                    :placeholder="'10'"
                    v-model="registrationStore.registeringCompany.yearsInBusiness"
                    :input-type="'number'"
                />
            </div>
            <div v-if="buyingLeads">
                <p>Who will call the leads?</p>
                <Dropdown
                    :options="leadCallOptions"
                    v-model="registrationStore.registeringCompany.whoCallsLeads"
                    :selected-option="registrationStore.registeringCompany.whoCallsLeads"
                />
            </div>
            <div  v-if="buyingLeads">
                <p>Who do you currently buy leads from?</p>
                <CustomInput
                    :placeholder="'e.g., LeadVendor Inc.'"
                    v-model="registrationStore.registeringCompany.buyingLeadsFrom"
                />
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import CustomInput from "@/components/elements/CustomInput.vue";
import Dropdown from "@/components/elements/Dropdown.vue";
import {computed, ref} from "vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import Slide from "@/components/slides/Slide.vue";

const registrationStore = useRegistrationStore();
const yesNoOptions = [
    {label: 'Yes', value: 'yes'},
    {label: 'No', value: 'no'},
];
const leadCallOptions = [
    {label: 'I will call the leads', value: 'I will call the leads'},
    {label: 'We have a call centre and autodialler set up', value: 'We have a call centre and autodialler set up'},
    {label: 'We have a team of appointment setters', value: 'We have a team of appointment setters'}
];
const turnoverOptions = [
    {label: 'Less than 1 million', value: 'Less than 1 million'},
    {label: '1-5 million', value: '1-5 million'},
    {label: '5-20 million', value: '5-20 million'},
    {label: '20-50 million', value: '20-50 million'},
    {label: '50-100 million', value: '50-100 million'},
    {label: '100 million+', value: '100 million+'},
    {label: "Don't know", value: "Don't know"},
];

const props = defineProps({
    title: {
        type: String,
        default: 'Define Your Company Metrics and Preferences'
    },
    subtitle: {
        type: String,
        default: 'Provide details about your company’s operations, tools, and lead management preferences.'
    }
});

const canContinue = computed(() => true);
const buyingLeads = computed(() => registrationStore.registeringCompany.buyingLeads.toLowerCase() === 'yes');
const slidePayload = computed(() => {
    const data: any = {};

    if (registrationStore.registeringCompany.numberOfEmployees) {
        data['number_of_employees'] = registrationStore.registeringCompany.numberOfEmployees;
    }
    if (registrationStore.registeringCompany.companyTurnover) {
        data['company_turnover'] = registrationStore.registeringCompany.companyTurnover;
    }
    if (registrationStore.registeringCompany.usesCRM) {
        data['uses_crm'] = registrationStore.registeringCompany.usesCRM;
    }
    if (registrationStore.registeringCompany.whoCallsLeads) {
        data['who_calls_leads'] = registrationStore.registeringCompany.whoCallsLeads;
    }
    if (registrationStore.registeringCompany.buyingLeadsFrom) {
        data['buying_leads_from'] = registrationStore.registeringCompany.buyingLeadsFrom;
    }
    if (registrationStore.registeringCompany.yearsInBusiness) {
        data['years_in_business'] = registrationStore.registeringCompany.yearsInBusiness;
    }

    return data;
});

defineExpose({
    canContinue,
    slidePayload
});

</script>